import { render } from "./DefinitionModal.vue?vue&type=template&id=7dba0a66&scoped=true"
import script from "./DefinitionModal.vue?vue&type=script&lang=js"
export * from "./DefinitionModal.vue?vue&type=script&lang=js"

import "./DefinitionModal.vue?vue&type=style&index=0&id=7dba0a66&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\versatech_vex\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dba0a66"]])

export default __exports__